var _circle, _path, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E4E4E4",
    fillOpacity: 0.49776
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0568 10.0001C16.5469 9.9859 13.2856 11.807 11.4605 14.8003C9.63543 17.7937 9.51292 21.5223 11.1376 24.6286L11.3379 25.0191C11.5021 25.3264 11.5364 25.6864 11.4333 26.0191C11.1474 26.7784 10.9085 27.5544 10.7178 28.3429C10.7178 28.7429 10.8323 28.9715 11.2616 28.962C12.0219 28.7941 12.7707 28.5777 13.5033 28.3143C13.8189 28.2274 14.1544 28.2475 14.4572 28.3715C14.7339 28.5048 15.2967 28.8477 15.3158 28.8477C18.9915 30.7804 23.4808 30.2472 26.5998 27.5074C29.7187 24.7676 30.8199 20.39 29.3676 16.504C27.9153 12.6181 24.2111 10.0305 20.0568 10.0001V10.0001Z",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 15.2871,
    cy: 20.0001,
    rx: 0.476965,
    ry: 0.47619,
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 20.0568,
    cy: 20.0001,
    rx: 0.476965,
    ry: 0.47619,
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 24.8265,
    cy: 20.0001,
    rx: 0.476965,
    ry: 0.47619,
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.bb811d7bc449107aee5bb6993c73916f.svg";
export { ForwardRef as ReactComponent };